module.exports = __webpack_public_path__ + "static/media/coolant-temp.d17f757e.svg";